import { jsx as G } from "react/jsx-runtime";
import { c as B } from "../../index-C3-ZVs5E.js";
import * as S from "react";
import R, { useState as X, useCallback as H, useEffect as $ } from "react";
import { _ as j } from "../../extends-hS2Bh-Yp.js";
import { _ as D } from "../../objectWithoutPropertiesLoose-DhwSMsjf.js";
import { i as I } from "../../use-isomorphic-layout-effect.browser.esm-DERp5kr6.js";
import { useEffectOnce as O } from "../utils.js";
import { TextareaSizeEnum as _, TextareaThemeEnum as C } from "./types.js";
import '../../assets/Textarea.css';var P = function(e) {
  var t = R.useRef(e);
  return I(function() {
    t.current = e;
  }), t;
}, F = function(e, t) {
  if (typeof e == "function") {
    e(t);
    return;
  }
  e.current = t;
}, Y = function(e, t) {
  var r = R.useRef();
  return R.useCallback(function(i) {
    e.current = i, r.current && F(r.current, null), r.current = t, t && F(t, i);
  }, [t]);
}, M = {
  "min-height": "0",
  "max-height": "none",
  height: "0",
  visibility: "hidden",
  overflow: "hidden",
  position: "absolute",
  "z-index": "-1000",
  top: "0",
  right: "0",
  display: "block"
}, q = function(e) {
  Object.keys(M).forEach(function(t) {
    e.style.setProperty(t, M[t], "important");
  });
}, W = q, o = null, k = function(e, t) {
  var r = e.scrollHeight;
  return t.sizingStyle.boxSizing === "border-box" ? r + t.borderSize : r - t.paddingSize;
};
function U(n, e, t, r) {
  t === void 0 && (t = 1), r === void 0 && (r = 1 / 0), o || (o = document.createElement("textarea"), o.setAttribute("tabindex", "-1"), o.setAttribute("aria-hidden", "true"), W(o)), o.parentNode === null && document.body.appendChild(o);
  var i = n.paddingSize, u = n.borderSize, d = n.sizingStyle, x = d.boxSizing;
  Object.keys(d).forEach(function(f) {
    var b = f;
    o.style[b] = d[b];
  }), W(o), o.value = e;
  var c = k(o, n);
  o.value = e, c = k(o, n), o.value = "x";
  var v = o.scrollHeight - i, a = v * t;
  x === "border-box" && (a = a + i + u), c = Math.max(a, c);
  var l = v * r;
  return x === "border-box" && (l = l + i + u), c = Math.min(l, c), [c, v];
}
var A = function() {
}, Z = function(e, t) {
  return e.reduce(function(r, i) {
    return r[i] = t[i], r;
  }, {});
}, J = [
  "borderBottomWidth",
  "borderLeftWidth",
  "borderRightWidth",
  "borderTopWidth",
  "boxSizing",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontWeight",
  "letterSpacing",
  "lineHeight",
  "paddingBottom",
  "paddingLeft",
  "paddingRight",
  "paddingTop",
  // non-standard
  "tabSize",
  "textIndent",
  // non-standard
  "textRendering",
  "textTransform",
  "width",
  "wordBreak",
  "wordSpacing",
  "scrollbarGutter"
], K = !!document.documentElement.currentStyle, Q = function(e) {
  var t = window.getComputedStyle(e);
  if (t === null)
    return null;
  var r = Z(J, t), i = r.boxSizing;
  if (i === "")
    return null;
  K && i === "border-box" && (r.width = parseFloat(r.width) + parseFloat(r.borderRightWidth) + parseFloat(r.borderLeftWidth) + parseFloat(r.paddingRight) + parseFloat(r.paddingLeft) + "px");
  var u = parseFloat(r.paddingBottom) + parseFloat(r.paddingTop), d = parseFloat(r.borderBottomWidth) + parseFloat(r.borderTopWidth);
  return {
    sizingStyle: r,
    paddingSize: u,
    borderSize: d
  };
}, V = Q;
function w(n, e, t) {
  var r = P(t);
  S.useLayoutEffect(function() {
    var i = function(d) {
      return r.current(d);
    };
    if (n)
      return n.addEventListener(e, i), function() {
        return n.removeEventListener(e, i);
      };
  }, []);
}
var ee = function(e, t) {
  w(document.body, "reset", function(r) {
    e.current.form === r.target && t(r);
  });
}, te = function(e) {
  w(window, "resize", e);
}, re = function(e) {
  w(document.fonts, "loadingdone", e);
}, ne = ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"], ie = function(e, t) {
  var r = e.cacheMeasurements, i = e.maxRows, u = e.minRows, d = e.onChange, x = d === void 0 ? A : d, c = e.onHeightChange, v = c === void 0 ? A : c, a = D(e, ne), l = a.value !== void 0, f = S.useRef(null), b = Y(f, t), y = S.useRef(0), g = S.useRef(), z = function() {
    var h = f.current, E = r && g.current ? g.current : V(h);
    if (E) {
      g.current = E;
      var T = U(E, h.value || h.placeholder || "x", u, i), L = T[0], N = T[1];
      y.current !== L && (y.current = L, h.style.setProperty("height", L + "px", "important"), v(L, {
        rowHeight: N
      }));
    }
  }, s = function(h) {
    l || z(), x(h);
  };
  return S.useLayoutEffect(z), ee(f, function() {
    if (!l) {
      var p = f.current.value;
      requestAnimationFrame(function() {
        var h = f.current;
        h && p !== h.value && z();
      });
    }
  }), te(z), re(z), /* @__PURE__ */ S.createElement("textarea", j({}, a, {
    onChange: s,
    ref: b
  }));
}, oe = /* @__PURE__ */ S.forwardRef(ie);
const ae = "_textarea_13d2v_2", se = "_sizeSM_13d2v_10", de = "_sizeMD_13d2v_16", ue = "_sizeLG_13d2v_22", ce = "_sizeXL_13d2v_29", fe = "_primary_13d2v_36", le = "_secondary_13d2v_54", he = "_transparent_13d2v_72", m = {
  textarea: ae,
  sizeSM: se,
  sizeMD: de,
  sizeLG: ue,
  sizeXL: ce,
  primary: fe,
  secondary: le,
  transparent: he
}, ye = ({
  value: n = "",
  textareaTheme: e,
  textareaSize: t,
  formatter: r,
  onInput: i,
  autoFocus: u,
  selectAllInitially: d,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  inputTheme: x,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  inputSize: c,
  ...v
}) => {
  const [a, l] = X(n), f = R.useRef(null), b = B({
    [m.textarea]: !0,
    [m.primary]: e === C.primary,
    [m.transparent]: e === C.transparent,
    [m.secondary]: e === C.secondary,
    [m.sizeSM]: t === _.sm,
    [m.sizeMD]: t === _.md,
    [m.sizeLG]: t === _.lg,
    [m.sizeXL]: t === _.xl
  }), y = r !== void 0, g = H(
    (s) => s ? y ? r(s) ?? "" : s : "",
    [r, y]
  ), z = H(
    (s) => {
      if (!(s.target instanceof HTMLTextAreaElement))
        return;
      const { value: p } = s.target;
      l(g(p)), i == null || i(p);
    },
    [g, i]
  );
  return O(
    H(() => {
      const s = f.current;
      if (u && s) {
        s.focus();
        const p = (a == null ? void 0 : a.length) ?? 0;
        s.selectionStart = s.selectionEnd = p, d && (s.selectionStart = 0);
      }
    }, [u, a == null ? void 0 : a.length, d])
  ), $(() => {
    l(g(n));
  }, [g, n]), /* @__PURE__ */ G(
    oe,
    {
      ...v,
      ref: f,
      className: b,
      autoComplete: "off",
      onInput: z,
      value: a,
      minRows: 5
    }
  );
};
export {
  ye as Textarea
};
